var map = {
	"./alert-order.svg": 69969,
	"./boleto-expired.svg": 96383,
	"./boleto-success.svg": 19692,
	"./color-bar-loading.svg": 90392,
	"./color-bar.svg": 38776,
	"./credit-card-limit.svg": 14101,
	"./credit-card-number.svg": 33265,
	"./logo.svg": 82835,
	"./order-canceled.svg": 11659,
	"./payment-fail.svg": 22054,
	"./pix-expired.svg": 78904,
	"./pix.svg": 49144,
	"./product-out-of-stock.svg": 42687,
	"./success.svg": 41185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;